<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout column align-center justify-center>
        <h1 class="display-2 primary--text" >Whoops, 404</h1>
        <p>Запрашиваемая страница не существует</p>
        <v-btn outline color="primary" @click="goToHome">На главную</v-btn>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
  export default {
    name: 'PageNotFound',
    
    methods: {
      goToHome(){
        this.$router.push({name: 'HomePage'})
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PageNotFound.vue